import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button as AntdButton } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ContactContext } from 'contexts/contactContext'

interface IProps {
  activeTab: 'resume' | 'legal_formalities' | 'staff' | string | undefined
  setActive: (active: string) => void
  children: React.ReactNode
}

const ContactHeader = (props: IProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { contact } = useContext(ContactContext)

  const activeTab = props.activeTab || 'resume'

  return (
    <Container>
      <Title>Formalités (Client {contact.id})</Title>

      <ButtonsContainer>
        <Button
          type={activeTab == 'resume' ? 'primary' : 'default'}
          onClick={() => {
            props.setActive('resume')
            navigate(`/contacts/${contact.id}/resume`)
          }}
        >
          {t('contact:menu.resume')}
        </Button>
        <Button disabled>{t('contact:menu.account')}</Button>
        <Button
          type={activeTab == 'staff' ? 'primary' : 'default'}
          onClick={() => {
            props.setActive('staff')
            navigate(`/contacts/${contact.id}/staff`)
          }}
        >
          {t('contact:menu.staff')}
        </Button>
        <Button
          type={activeTab == 'legal_formalities' ? 'primary' : 'default'}
          onClick={() => {
            props.setActive('legal_formalities')
            navigate(`/contacts/${contact.id}/legal_formalities`)
          }}
        >
          {t('contact:menu.legal_formalities')}
        </Button>
      </ButtonsContainer>

      {props.children && <div>{props.children}</div>}
    </Container>
  )
}

const Container = styled.div`
  background: white;
  padding: 16px 16px 0px 16px;
  width: 100%;
  border-bottom: 1px solid #d3d7da;
  margin-bottom: 16px;
`

const ButtonsContainer = styled.div`
  margin-bottom: 16px;
`

const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  padding-bottom: 16px;
`

const Button = styled(AntdButton)`
  margin-right: 8px;
`

export default ContactHeader
